import { Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 pb-8" }
const _hoisted_2 = { class: "m-auto pt-5" }
const _hoisted_3 = { class: "border-collapse w-full" }
const _hoisted_4 = { class: "whitespace-nowrap px-2" }
const _hoisted_5 = { class: "whitespace-nowrap px-2" }
const _hoisted_6 = { class: "whitespace-nowrap px-2" }
const _hoisted_7 = { class: "whitespace-nowrap px-2" }
const _hoisted_8 = { class: "whitespace-nowrap px-2" }
const _hoisted_9 = { class: "whitespace-nowrap px-2" }
const _hoisted_10 = { class: "whitespace-nowrap px-2" }
const _hoisted_11 = { class: "whitespace-nowrap px-2" }
const _hoisted_12 = { class: "whitespace-nowrap px-2" }
const _hoisted_13 = {
  class: "whitespace-nowrap px-2",
  colspan: "2"
}
const _hoisted_14 = {
  class: "whitespace-nowrap px-2",
  colspan: "2"
}
const _hoisted_15 = { class: "whitespace-nowrap px-2" }
const _hoisted_16 = { class: "whitespace-nowrap px-2" }
const _hoisted_17 = { class: "whitespace-nowrap px-2" }
const _hoisted_18 = { class: "whitespace-nowrap px-2" }
const _hoisted_19 = { class: "whitespace-nowrap px-2" }
const _hoisted_20 = { class: "flex flex-col col-span-2 mb-2 pt-3" }
const _hoisted_21 = { class: "flex justify-end" }
const _hoisted_22 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" })),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-3xl font-bold mb-4" }, "Dettaglio Oda", -1)),
        _createElementVNode("table", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Tipo documento"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Creazione"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Variazione"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Numero"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Data"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Progetto"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Nodo"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Descrizione"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Cliente")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.oda?.TIPODOCUMENTO), 1),
              _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.oda?.UTENTEINSERIMENTO), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.oda?.UTENTEVARIAZIONE), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.oda?.NUMDOC), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$filters.toDate(_ctx.oda?.DATADOC)), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.oda?.PROGETTO), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.oda?.NODO), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.oda?.DESCRIZIONENODO), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.oda?.CLIENTE), 1)
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "bg-white border-2 px-2",
                colspan: "2"
              }, "Ragione Sociale"),
              _createElementVNode("th", {
                class: "bg-white border-2 px-2",
                colspan: "2"
              }, "Partita IVA"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Valuta"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Cambio"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Descrizione"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Imponibile in €"),
              _createElementVNode("th", { class: "bg-white border-2 px-2" }, "Totale in €")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.oda?.RAGSOC), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.oda?.PARTITAIVA), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.oda?.VALUTA), 1),
              _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.oda?.CAMBIO), 1),
              _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.oda?.DESCRIZIONENODO), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$filters.toCurrency(_ctx.oda?.TOATLEIMPONIBILE)), 1),
              _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$filters.toCurrency(_ctx.oda?.TOTALEDOCUMENTO)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Field, {
            field_name: "Cerca",
            "onUpdate:modelValue": [
              _ctx.lista.debounceSearch,
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lista.search) = $event))
            ],
            modelValue: _ctx.lista.search,
            placeholder: "Cerca"
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_Paginator, {
            class: "",
            pagination: _ctx.lista.paginate
          }, null, 8, ["pagination"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 border-separate border-spacing-3 py-4",
            cols: _ctx.cols,
            "onUpdate:cols": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cols) = $event)),
            rows: _ctx.lista.rows,
            onOrderUpdate: _ctx.lista.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toFormat(c[_ctx.cols[3].prop], 0, 0)), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_4`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(c[_ctx.cols[4].prop])), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_5`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toCurrency(c[_ctx.cols[5].prop])), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_7`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(c[_ctx.cols[7].prop])), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_8`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(c[_ctx.cols[8].prop])), 1)
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_9`,
                fn: _withCtx((context) => [
                  _createTextVNode(_toDisplayString(_ctx.$filters.toEuroCurrency(c.IMPORTO_EURO - c.VALORETRASFORMATO )), 1)
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.lista.fetchNextPage,
          identifier: _ctx.lista.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre righe.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}